import { motion } from "framer-motion";
import { Wrapper } from "./Screen.styles";
import { NavigationType, useNavigationType } from "react-router";
import { useMemo } from "react";

interface Props {
  children: React.ReactNode;
  isAnimated?: boolean;
  id?: string;
}

export default function Screen({ children, isAnimated = false, id }: Props) {
  const navType: NavigationType = useNavigationType();

  const routeVariants = useMemo(() => {
    return {
      initial: {
        x: navType === NavigationType.Pop ? -30 : 30,
        opacity: 0,
      },
      final: {
        x: 0,
        opacity: 1,
      },
      exit: {
        x: navType === NavigationType.Pop ? 30 : -30,
        opacity: 0,
      },
    };
  }, [navType, id]);

  return isAnimated ? (
    <motion.div
      key={id}
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
      className="about component"
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  ) : (
    <Wrapper>{children}</Wrapper>
  );
}
